/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Projects from "./layouts/projects";
import SignIn from "./layouts/authentication/sign-in";
import BundleAnalysis from "./RetiredLayouts/BundleAnalysis";
import EntryScreen from "./layouts/EntryScreen";
import AllAssetsPage from "./RetiredLayouts/AllAssets";
import AssetExplorer from "./layouts/AssetExplorer";
import AssetComparisonPage from "./layouts/AssetComparison";
import ArtifactIngestion from "./layouts/ArtifactIngestion";
import AdminPage from "./layouts/AdminPage";
import ProjectManagement from "./layouts/ProjectManagement";
import AccountManagement from "./layouts/AccountManagement";
import RunHistory from "./layouts/RunHistory";
import RelationshipDiagrams from "./layouts/RelationshipDiagrams";
import GapsPage from "./layouts/GapsPage";
import ReportGenerator from "./layouts/ReportGenerator";
import RFPGenerator from "./layouts/RFPGenerator";
import ExtractedObjects from "./layouts/ExtractedObjects";
import ProjectSettings from "./layouts/ProjectSettings";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "collapse",
    name: "Projects",
    key: "projects",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/projects",
    component: <Projects />,
  },
  {
    type: "collapse",
    name: "Bundle Analysis",
    key: "bundle-analysis",
    icon: <Icon fontSize="small">analytics</Icon>,
    route: "/bundle-analysis",
    component: <BundleAnalysis />
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Home Page",
    key: "home-page",
    route: "/home",
    component: <EntryScreen />,
  },
  {
    type: "collapse",
    name: "All Assets",
    key: "all-assets",
    route: "/all-assets",
    component: <AllAssetsPage/>
  },
  {
    type: "collapse",
    name: "Asset Explorer",
    key: "asset-explorer",
    route: "/asset-explorer",
    component: <AssetExplorer />
  },
  {
    type: "collapse",
    name: "Asset Comparison",
    key: "asset-comparison",
    route: "/asset-comparison",
    component: <AssetComparisonPage />
  },
  {
    type: "collapse",
    name: "Artifact Ingestion",
    key: "artifact-ingestion",
    route: "/artifact-ingestion",
    component: <ArtifactIngestion />
  },
  {
    type: "collapse",
    name: "Admin Page",
    key: "admin-page",
    route: "/admin",
    component: <AdminPage />
  },
  {
    type: "collapse",
    name: "Project Management",
    key: "project-management",
    route: "/project-management",
    component: <ProjectManagement />
  },
  {
    type: "collapse",
    name: "Account Management",
    key: "account-management",
    route: "/account-management",
    component: <AccountManagement />
  },
  {
    type: "collapse",
    name: "Run History",
    key: "run-history",
    route: "/run-history",
    component: <RunHistory />
  },
  {
    type: "collapse",
    name: "Relationship Diagrams",
    key: "relationship-diagrams",
    route: "/relationship-diagrams",
    component: <RelationshipDiagrams />
  },
  {
    type: "collapse",
    name: "Gaps",
    key: "gaps",
    route: "/gaps",
    component: <GapsPage />
  },
  {
    type: "collapse",
    name: "Report Generator",
    key: "report-generator",
    route: "/report-generator",
    component: <ReportGenerator />
  },
  {
    type: "route",
    name: "RFP Generator",
    key: "rfp-generator",
    route: "/rfp-generator",
    icon: <Icon>description</Icon>,
    component: <RFPGenerator />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Project Settings",
    key: "project-settings",
    route: "/project-settings",
    icon: <Icon>settings</Icon>,
    component: <ProjectSettings />,
    noCollapse: true,
  },
  {
    type: "route",
    name: "Extracted Objects",
    key: "extracted-objects",
    route: "/extracted-objects",
    icon: <Icon>description</Icon>,
    component: <ExtractedObjects />,
    noCollapse: true,
  },
];

export default routes;
